const doc = [({"da":({"js":({"admin":({"photo_products":({"resource_select":({"select_resource_type":"Vælg resourcetype"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;